import { ServiceVariation } from "@/services/backend/omni/servicevariation/types/service-variation";
import { UUID } from "@bitory-gmbh/nidavellir";

/** Mirrors `scopeofwork.DefaultBaseDataKey`, backend/core/omni/domain/scopeofwork/base_data.go. */
export function omniScopeOfWorkBaseDataKey(serviceKind: string): string {
  return `omni.scopeOfWork.baseData.${serviceKind}`;
}

/** Mirrors `scopeofwork.BaseData`, backend/core/omni/domain/scopeofwork/base_data.go. */
export type ScopeOfWorkBaseData = {
  id: UUID;
  companyId: UUID;
  label: string;
  createdAt: string;
  updatedAt: string;
  serviceKind: string;
  serviceVariation: ServiceVariation;
  title: string;
  subtitle: string;
  text: string;
};

/** Mirrors `scopeofwork.BaseDataPatch`, backend/core/omni/domain/scopeofwork/base_data.go. */
export type ScopeOfWorkBaseDataPatch = {
  label?: string;
  serviceVariation?: ServiceVariation;
  title?: string;
  subtitle?: string;
  text?: string;
};

export function patchScopeOfWorkBaseData(
  baseData: ScopeOfWorkBaseData,
  patch: ScopeOfWorkBaseDataPatch,
): ScopeOfWorkBaseData {
  return { ...baseData, ...patch };
}
